import { render, staticRenderFns } from "./car_Repair.vue?vue&type=template&id=4864cd08&scoped=true"
import script from "./car_Repair.vue?vue&type=script&lang=js"
export * from "./car_Repair.vue?vue&type=script&lang=js"
import style0 from "./car_Repair.vue?vue&type=style&index=0&id=4864cd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4864cd08",
  null
  
)

export default component.exports